/*Update the new/best/sale menu link*/
$(document).ready(function() {
    // Define the target URL
    var targetUrl = '/collections/best-new';

    // Find the anchor tag with the specific href attribute
    var $targetAnchorDesktop = $('div#HeaderWrapper a[href="' + targetUrl + '"]');

    // Check if the anchor tag with the specified URL exists
    if ($targetAnchorDesktop.length > 0) {
      // Update the text content
       $targetAnchorDesktop.html('BEST<span class="dot">•NEW <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
    }
  });

$(document).ready(function() {
    // Define the target URL
    var targetUrl ='/collections/best-new';

    // Find the anchor tag with the specific href attribute
    var $targetAnchorMobile = $('.mobile-nav__has-sublist a[href="' + targetUrl + '"]');

    // Check if the anchor tag with the specified URL exists
    if ($targetAnchorMobile.length > 0) {
      // Update the text content
       $targetAnchorMobile.html('BEST<span class="dot">•NEW'); // Replace with your desired text
    }
});

$(document).ready(function() {
   var windowLocationpage = window.location.pathname;
      if (windowLocationpage == "/pages/artistrybyaltenew"){
        $("div#CollectionSection-template--17166230061113__featured-collection .view-options-jm").css("margin","0px");
      }
});

 $(document).ready(function() {
    var updatedText = 'Back to <span class="back-to-alt">Altenew.com</span>';
    $('#Sublabel-https-altenew-com1').html(updatedText);
});

$(document).ready(function() {
  $("nav.breadcrumb a[title='Back to the frontpage']").attr("href","https://altenew.com/pages/artistrybyaltenew");
});